export const isTruthyOrZero = (value: unknown): boolean => {
  return !(value === null || value === undefined || value === '' || value === false || (typeof value === 'number' && isNaN(value)));
};
